export function fillterCollapse(collapseContainer, rollDown, rollUp) {

    if (!collapseContainer && !rollDown) { return }

    if (rollUp) {
        rollDown.addEventListener('click', function () {
            $(collapseContainer).slideDown();
        })

        rollUp.addEventListener('click', function () {
            $(collapseContainer).slideUp();
            scrollUp();
        })
    } else {
        let trigger = 0;

        rollDown.addEventListener('click', function () {
            $(collapseContainer).slideToggle();

            if (++trigger % 2 === 0) {
                scrollUp();
            }
        })
    }

    function scrollUp() {
        $('html, body').animate({
            'scrollTop': 0
        }, 500);
    }

    $(window).on('resize', function () {
        if (window.innerWidth >= 992) {
            $(collapseContainer).slideDown();
        }
    })
};



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/collapse_fillter.js